import React, { useEffect, useMemo } from 'react';
import LegalLayout from './LegalLayout';

const TERMS_TEXT = String.raw`TERMOS DE USO E CONTRATO DE PRESTAÇÃO DE SERVIÇOS SaaS
PLATAFORMA LUMIX ÓTICAS

Última atualização: 28 de maio de 2026


1. IDENTIFICAÇÃO DAS PARTES

1.1. Estes Termos de Uso e Contrato de Prestação de Serviços SaaS (“Termos”) regulam o acesso e a utilização da plataforma Lumix Óticas (“Plataforma”), solução tecnológica em nuvem voltada à gestão de óticas, CRM, ordens de serviço, estoque, financeiro, campanhas, automações, pós-venda, anexos, relatórios e demais funcionalidades disponibilizadas.

1.2. Para fins destes Termos:
a) “Lumix”, “Lumix Óticas”, “nós” ou “Contratada” significa [INSERIR RAZÃO SOCIAL], pessoa jurídica inscrita no CNPJ sob nº [INSERIR CNPJ], com sede em [INSERIR ENDEREÇO], e-mail de contato [INSERIR E-MAIL];
b) “Contratante”, “Cliente” ou “Empresa Contratante” significa a pessoa jurídica, empresário individual, MEI, profissional ou organização que contrata, paga, testa, acessa ou utiliza a Plataforma para fins empresariais;
c) “Usuário” significa qualquer pessoa autorizada pela Contratante a acessar a Plataforma, incluindo administradores, colaboradores, atendentes, vendedores, gestores e operadores;
d) “Cliente Final” significa a pessoa atendida pela Contratante no exercício de sua atividade comercial, incluindo consumidores da ótica, leads, contatos, pacientes/clientes cadastrados, destinatários de mensagens e titulares dos dados inseridos na Plataforma;
e) “Dados da Contratante” significa todo conteúdo, dado, arquivo, imagem, receita, anexo, documento, cadastro, mensagem, relatório, ordem de serviço, informação fiscal, informação financeira ou registro inserido, importado, transmitido ou gerado pela Contratante ou por seus Usuários na Plataforma;
f) “Serviços de Terceiros” significa serviços, APIs, gateways, provedores de hospedagem, armazenamento, pagamento, e-mail, mensageria, WhatsApp, emissão fiscal, infraestrutura, autenticação ou qualquer solução externa integrada à Plataforma.

2. NATUREZA B2B DA CONTRATAÇÃO

2.1. A Plataforma é destinada prioritariamente ao uso empresarial por óticas, redes de óticas, gestores, administradores e profissionais que utilizam o sistema como ferramenta de trabalho, organização e gestão interna.

2.2. Ao contratar ou utilizar a Plataforma, a Contratante declara que:
a) possui capacidade jurídica e poderes suficientes para contratar em nome da empresa ou organização que representa;
b) utilizará a Plataforma para finalidade empresarial, profissional ou institucional;
c) reconhece que o sistema é uma ferramenta de apoio operacional e não substitui consultoria jurídica, contábil, fiscal, médica, optométrica, oftalmológica ou administrativa especializada;
d) é responsável por avaliar se a Plataforma atende às suas necessidades específicas antes de utilizá-la em produção.

2.3. Quando normas de proteção ao consumidor forem aplicáveis por determinação legal, estes Termos serão interpretados de forma compatível com a legislação vigente. Nenhuma cláusula destes Termos afasta direitos obrigatórios e irrenunciáveis previstos em lei.

3. ACEITE ELETRÔNICO

3.1. A Contratante aceita estes Termos ao realizar qualquer uma das seguintes ações:
a) criar conta;
b) concluir cadastro;
c) acessar o painel;
d) iniciar teste, implantação ou contratação;
e) efetuar pagamento;
f) utilizar qualquer funcionalidade da Plataforma;
g) marcar caixa de aceite eletrônico;
h) manter o uso da Plataforma após atualização destes Termos.

3.2. O aceite eletrônico possui plena validade para comprovação da contratação, podendo a Lumix registrar data, hora, IP, dispositivo, usuário, e-mail, empresa, logs de acesso, identificadores técnicos e demais evidências necessárias para auditoria, segurança, cobrança, prevenção a fraudes e exercício regular de direitos.

3.3. Caso o Usuário não concorde com estes Termos, deverá interromper imediatamente o uso da Plataforma e solicitar o cancelamento pelos canais oficiais.

4. OBJETO

4.1. A Lumix concede à Contratante uma licença limitada, revogável, não exclusiva, intransferível e condicionada ao pagamento, para acesso e uso da Plataforma em ambiente SaaS, conforme plano contratado, funcionalidades disponíveis, limites técnicos, regras comerciais e políticas aplicáveis.

4.2. A contratação não implica venda de software, cessão de código-fonte, transferência de propriedade intelectual, exclusividade, representação comercial, sociedade, franquia, vínculo trabalhista ou qualquer forma de associação entre as partes.

4.3. A Lumix poderá disponibilizar módulos, recursos, integrações, automações, relatórios, painéis, fluxos de atendimento, ferramentas fiscais, importação de bases, geração de documentos, envio de mensagens, armazenamento de anexos e demais funcionalidades, sempre de acordo com o plano contratado e a disponibilidade técnica.

5. CONTA, ADMINISTRADOR E USUÁRIOS

5.1. A Contratante é integralmente responsável pelas informações fornecidas no cadastro e deve mantê-las corretas, completas e atualizadas.

5.2. O administrador principal da conta será responsável por:
a) criar, editar, remover e controlar acessos de Usuários;
b) definir permissões internas;
c) manter sigilo de credenciais;
d) encerrar acessos de ex-colaboradores;
e) fiscalizar o uso da conta por sua equipe;
f) garantir que seus Usuários cumpram estes Termos e a legislação aplicável.

5.3. Logins e senhas são pessoais e intransferíveis. A Contratante responde por toda atividade realizada em sua conta, salvo se comprovar falha exclusiva da Lumix.

5.4. A Lumix poderá bloquear, limitar ou suspender acessos em caso de suspeita de fraude, invasão, uso indevido, risco à segurança, violação destes Termos, ordem legal, inadimplência ou necessidade técnica urgente.

6. PLANOS, LIMITES, RECURSOS E ALTERAÇÕES DA PLATAFORMA

6.1. Os recursos disponíveis dependem do plano contratado, quantidade de empresas/unidades, usuários, módulos, limites de armazenamento, integrações, automações, suporte e condições comerciais vigentes.

6.2. A Lumix poderá aprimorar, alterar, substituir, remover, limitar ou reorganizar funcionalidades para melhorar desempenho, segurança, usabilidade, conformidade legal, estabilidade ou viabilidade econômica do serviço.

6.3. Alterações que impactem materialmente o uso contratado serão comunicadas por meios razoáveis, como aviso no painel, e-mail, WhatsApp oficial, changelog ou atualização destes Termos.

6.4. Recursos identificados como beta, piloto, teste, laboratório, implantação comercial, grupo de fundadores, experimental ou pré-lançamento podem conter instabilidades, mudanças frequentes, limitações, falhas temporárias, indisponibilidades ou substituições.

6.5. A Contratante reconhece que a evolução contínua da Plataforma faz parte da natureza SaaS do serviço.

7. IMPLANTAÇÃO COMERCIAL, TESTES E GRUPO DE FUNDADORES

7.1. A Lumix poderá oferecer condições especiais para empresas em fase de implantação comercial, teste, piloto ou grupo de fundadores.

7.2. Nesses casos, a Contratante reconhece que:
a) a Plataforma poderá passar por ajustes frequentes;
b) algumas funcionalidades poderão ser alteradas, descontinuadas ou reconstruídas;
c) o uso real poderá gerar melhorias, correções e adaptações;
d) eventuais benefícios comerciais poderão ser limitados, temporários ou condicionados a regras específicas;
e) a Lumix poderá coletar feedbacks, métricas de uso e informações técnicas para melhoria do produto, observada a legislação aplicável.

7.3. A participação em fase de implantação comercial não gera direito adquirido à manutenção eterna de funcionalidades, valores promocionais, descontos, benefícios ou condições não expressamente formalizadas por escrito.

8. PAGAMENTOS, ASSINATURA, CUPONS E REAJUSTES

8.1. O acesso à Plataforma depende do pagamento dos valores correspondentes ao plano contratado, salvo período gratuito, teste, bonificação ou condição promocional expressamente concedida.

8.2. A cobrança poderá ser mensal, anual, recorrente ou conforme condição comercial aceita pela Contratante.

8.3. A ativação plena da conta poderá depender da confirmação do pagamento por gateway, intermediador financeiro, instituição bancária, cartão, Pix, boleto ou outro meio disponível.

8.4. Salvo indicação expressa em contrário, cupons, descontos, bônus e condições promocionais:
a) aplicam-se exclusivamente à primeira mensalidade ou ao primeiro ciclo indicado;
b) não são cumulativos;
c) não geram direito adquirido;
d) podem depender de validação antifraude;
e) podem ser cancelados em caso de abuso, duplicidade, fraude ou descumprimento das regras da campanha;
f) não se aplicam automaticamente a renovações, upgrades, novas unidades, módulos adicionais ou períodos futuros.

8.5. A partir do segundo ciclo, salvo condição expressamente diferente, a assinatura será cobrada pelo valor normal vigente ou pelo valor contratado para o respectivo plano.

8.6. A Lumix poderá reajustar preços mediante aviso prévio razoável, especialmente em razão de custos de infraestrutura, inflação, novos módulos, aumento de armazenamento, integrações, custos de terceiros, tributos ou reposicionamento comercial.

8.7. Impostos, taxas, tarifas bancárias, encargos de gateway, chargebacks, custos de emissão fiscal e demais valores incidentes poderão ser repassados quando aplicável e permitido por lei.

9. INADIMPLÊNCIA, SUSPENSÃO E CANCELAMENTO

9.1. O atraso no pagamento poderá gerar aviso de cobrança, restrição parcial de funcionalidades, suspensão temporária, bloqueio de novas operações, interrupção de integrações e, após prazo razoável, cancelamento da conta.

9.2. A suspensão por inadimplência não elimina a obrigação de pagamento dos valores vencidos, encargos aplicáveis ou valores proporcionais já utilizados.

9.3. A reativação da conta poderá ocorrer após confirmação da regularização financeira, observados prazos técnicos, bancários e de processamento por terceiros.

9.4. Caso a inadimplência persista, a Lumix poderá encerrar a conta e iniciar procedimento de retenção, exportação, arquivamento, anonimização ou exclusão dos Dados da Contratante, conforme estes Termos, a Política de Privacidade, a legislação aplicável e obrigações de guarda.

9.5. A Contratante poderá solicitar cancelamento pelos canais oficiais. O cancelamento impede novas cobranças futuras, mas não gera, por si só, reembolso automático de período já iniciado, salvo obrigação legal, falha comprovada da Lumix ou condição comercial expressamente pactuada.

10. DIREITO DE ARREPENDIMENTO E REEMBOLSOS

10.1. Quando a contratação estiver sujeita à legislação consumerista e for realizada fora do estabelecimento comercial, eventual direito de arrependimento será respeitado nos termos da lei aplicável.

10.2. Em contratações empresariais B2B, utilizadas como insumo da atividade econômica da Contratante, reembolsos seguirão as condições comerciais contratadas, a política vigente e a legislação aplicável.

10.3. Não haverá reembolso por:
a) uso parcial do ciclo contratado;
b) cancelamento por decisão unilateral da Contratante após ativação do serviço;
c) suspensão decorrente de inadimplência;
d) violação destes Termos;
e) bloqueio por uso abusivo;
f) indisponibilidade causada por terceiros, força maior ou falha imputável à própria Contratante.

10.4. Esta cláusula não limita direitos obrigatórios previstos em lei.

11. OBRIGAÇÕES DA CONTRATANTE

11.1. A Contratante obriga-se a:
a) utilizar a Plataforma de forma lícita, ética e compatível com estes Termos;
b) fornecer dados verdadeiros e atualizados;
c) obter autorizações, consentimentos, bases legais e permissões necessárias para cadastrar, importar, tratar e contatar Clientes Finais;
d) manter sua própria política de privacidade, avisos, autorizações e documentos internos quando exigidos;
e) respeitar a LGPD, o Código de Defesa do Consumidor, normas fiscais, normas profissionais, regras de publicidade, regras de mensageria e demais normas aplicáveis à sua atividade;
f) não utilizar a Plataforma para spam, fraude, golpe, assédio, discriminação, conteúdo ilícito ou prática abusiva;
g) conferir dados antes de emitir documentos, enviar mensagens, gerar relatórios, importar bases ou executar automações;
h) manter backup próprio ou exportação de dados relevantes quando necessário à sua operação;
i) treinar seus colaboradores para uso adequado da Plataforma;
j) responder por atos, omissões, erros, cadastros, mensagens, campanhas e decisões de seus Usuários.

12. USO ACEITÁVEL

12.1. É proibido:
a) tentar invadir, explorar vulnerabilidades, derrubar, sobrecarregar, escanear ou comprometer a Plataforma;
b) realizar engenharia reversa, copiar, modificar, vender, sublicenciar ou reproduzir a Plataforma sem autorização;
c) acessar dados de outras empresas;
d) compartilhar credenciais com terceiros não autorizados;
e) burlar limites de plano, bloqueios, validações, regras de pagamento ou mecanismos de segurança;
f) inserir vírus, malware, scripts maliciosos, automações não autorizadas ou códigos nocivos;
g) usar a Plataforma para envio de mensagens sem base legal, spam, disparos abusivos, pirâmides, fraude, propaganda enganosa ou conteúdo ilícito;
h) armazenar dados ou documentos que não tenham relação legítima com a operação da Contratante;
i) violar direitos de propriedade intelectual, imagem, privacidade, honra ou dados pessoais de terceiros;
j) utilizar a Plataforma de forma que possa prejudicar a Lumix, outros clientes, terceiros, provedores, infraestrutura, reputação ou disponibilidade do serviço.

12.2. A violação desta cláusula autoriza a Lumix a suspender ou encerrar a conta, sem prejuízo de cobrança de valores devidos, reparação por perdas e danos e comunicação às autoridades competentes quando necessário.

13. WHATSAPP, MENSAGENS, CAMPANHAS E AUTOMAÇÕES

13.1. Funcionalidades de envio de mensagens, campanhas, pós-venda, lembretes, WhatsApp, e-mail, SMS ou canais similares são ferramentas de apoio. A Contratante é a única responsável pelo conteúdo, público, frequência, base legal, autorização de contato, abordagem comercial e atendimento aos pedidos de descadastro, bloqueio ou oposição dos destinatários.

13.2. A Contratante declara que somente enviará mensagens a destinatários com relação legítima, autorização, base legal adequada ou contexto comercial permitido, mantendo meios para atender solicitações de opt-out, exclusão, oposição ou interrupção de contato.

13.3. A Lumix não garante entrega, leitura, resposta, conversão, disponibilidade, permanência, não bloqueio ou funcionamento contínuo de canais de terceiros, incluindo WhatsApp, Meta, provedores de e-mail, APIs, gateways e bibliotecas externas.

13.4. Bloqueios de número, limitações, banimentos, restrições, falhas de envio, perda de sessão, alteração de regras por terceiros ou instabilidades em canais externos não serão responsabilidade da Lumix quando decorrerem de políticas, decisões, sistemas ou ações de terceiros, uso indevido, volume abusivo, conteúdo inadequado ou descumprimento de regras pela Contratante.

13.5. A Lumix poderá suspender disparos, limitar volume, bloquear campanhas ou interromper integrações quando identificar risco de spam, abuso, violação legal, risco reputacional, instabilidade técnica ou descumprimento destes Termos.

14. DADOS, ANEXOS, RECEITAS, IMAGENS E DOCUMENTOS

14.1. A Contratante é responsável por todos os Dados da Contratante inseridos, importados, armazenados, transmitidos ou processados na Plataforma.

14.2. A Plataforma poderá permitir armazenamento de documentos, fotos de receitas, fotos de óculos, imagens, comprovantes, anexos, dados de ordem de serviço, dados de compra, dados de entrega, dados financeiros, dados fiscais, informações de contato e demais registros operacionais.

14.3. A Lumix não audita previamente o conteúdo dos documentos enviados e não se responsabiliza por:
a) ausência de autorização do titular;
b) documento ilegível, falso, incorreto, incompleto ou desatualizado;
c) uso indevido de imagem;
d) violação de sigilo profissional;
e) exposição indevida causada por Usuários da Contratante;
f) cadastro de dados sem base legal;
g) conteúdo inserido por erro, abuso ou fraude da Contratante.

14.4. A Contratante deve evitar inserir dados desnecessários e deve manter apenas informações pertinentes à finalidade operacional, observando os princípios de necessidade, finalidade, adequação, transparência, segurança e prevenção.

15. PROTEÇÃO DE DADOS PESSOAIS E LGPD

15.1. As partes comprometem-se a cumprir a Lei Geral de Proteção de Dados Pessoais (LGPD), o Marco Civil da Internet e demais normas aplicáveis à privacidade, segurança da informação e proteção de dados.

15.2. Em relação aos dados pessoais de Clientes Finais inseridos pela Contratante na Plataforma, a Contratante atuará, em regra, como Controladora, pois define as finalidades, bases legais, categorias de dados, tempo de retenção, destinatários, campanhas, atendimentos e decisões sobre o tratamento.

15.3. Em relação aos dados pessoais de Clientes Finais tratados dentro da Plataforma por instrução da Contratante, a Lumix atuará, em regra, como Operadora, tratando os dados conforme instruções lícitas da Contratante, estes Termos, a Política de Privacidade, o contrato, obrigações legais, medidas de segurança e necessidades técnicas da prestação do serviço.

15.4. Em relação aos dados da própria Contratante, seus representantes, administradores, usuários, responsáveis financeiros, leads comerciais, pagadores e contatos de suporte, a Lumix poderá atuar como Controladora para finalidades próprias, incluindo cadastro, autenticação, cobrança, suporte, prevenção a fraudes, segurança, comunicação, marketing institucional, emissão fiscal, cumprimento de obrigações legais e exercício regular de direitos.

15.5. A Contratante declara e garante que possui base legal adequada para:
a) coletar dados de Clientes Finais;
b) inserir dados na Plataforma;
c) armazenar documentos, imagens, receitas e anexos;
d) importar listas de contatos;
e) enviar mensagens e campanhas;
f) realizar automações de relacionamento;
g) tratar dados pessoais sensíveis, quando aplicável;
h) compartilhar dados com a Lumix e Serviços de Terceiros necessários à prestação do serviço.

15.6. A Contratante reconhece que receitas oftalmológicas, informações de saúde visual, prescrições, exames, documentos médicos, laudos, dados biométricos ou qualquer dado relacionado à saúde podem ser considerados dados pessoais sensíveis. Nesses casos, a Contratante deve adotar cautelas reforçadas, utilizar base legal adequada, limitar acessos internos, orientar seus colaboradores e manter documentação comprobatória quando necessário.

15.7. A Lumix adotará medidas técnicas e administrativas razoáveis para proteger os dados pessoais contra acessos não autorizados, perda, alteração, destruição, comunicação indevida ou tratamento inadequado, considerando o porte da operação, os riscos envolvidos, o estado da técnica e a natureza SaaS do serviço.

15.8. As medidas de segurança poderão incluir, conforme aplicável:
a) autenticação por login e senha;
b) controle de acesso por usuário;
c) segregação lógica por empresa;
d) registros de acesso e auditoria;
e) criptografia ou proteção em trânsito;
f) restrição de acesso interno;
g) backups e rotinas de recuperação;
h) monitoramento técnico;
i) políticas internas de confidencialidade;
j) adoção de provedores com padrões de segurança compatíveis.

15.9. Nenhum sistema é absolutamente imune a falhas, ataques, indisponibilidades, erros humanos ou incidentes. A Lumix não promete segurança absoluta, mas compromete-se a empregar esforços razoáveis e proporcionais para prevenção, detecção, mitigação e resposta a incidentes.

15.10. A Lumix poderá utilizar suboperadores e fornecedores necessários à prestação do serviço, incluindo hospedagem, banco de dados, armazenamento, envio de e-mails, pagamentos, emissão fiscal, mensageria, analytics, monitoramento, suporte e infraestrutura, exigindo deles compromissos compatíveis de segurança e confidencialidade sempre que aplicável.

15.11. Caso haja transferência internacional de dados, a Lumix adotará mecanismos compatíveis com a LGPD e regulamentação aplicável, incluindo cláusulas contratuais, salvaguardas, medidas técnicas, controles de segurança ou outro mecanismo admitido em lei.

15.12. Solicitações de titulares de dados recebidas diretamente pela Lumix e relacionadas a dados controlados pela Contratante poderão ser encaminhadas à Contratante para avaliação e resposta, salvo quando a Lumix também atuar como Controladora em relação ao respectivo dado.

15.13. A Contratante é responsável por responder aos Clientes Finais sobre seus direitos de titular, incluindo confirmação de tratamento, acesso, correção, anonimização, bloqueio, eliminação, portabilidade, informação, oposição e revogação de consentimento, quando aplicáveis.

15.14. A Lumix poderá auxiliar a Contratante, na medida do possível e dentro de limites técnicos razoáveis, a localizar, exportar, corrigir ou excluir dados, desde que a solicitação seja legítima, tecnicamente viável e não viole obrigação legal, direito de terceiros, segurança ou integridade da Plataforma.

16. INCIDENTES DE SEGURANÇA

16.1. Caso a Lumix identifique incidente de segurança envolvendo dados pessoais sob sua operação e com risco ou dano relevante aos titulares, adotará medidas razoáveis para contenção, investigação, mitigação e comunicação à Contratante, quando esta atuar como Controladora.

16.2. A responsabilidade legal de comunicação à ANPD e aos titulares será definida conforme o papel de cada parte no tratamento e a legislação aplicável.

16.3. A Contratante deverá comunicar imediatamente à Lumix qualquer suspeita de vazamento, acesso indevido, perda de senha, uso irregular, invasão, comprometimento de conta, exposição de dados, envio indevido ou incidente envolvendo a Plataforma.

16.4. A Lumix poderá tomar medidas emergenciais para proteger a Plataforma, incluindo reset de senha, revogação de sessões, bloqueio de usuários, suspensão temporária, limitação de recursos, preservação de logs e investigação técnica.

17. RETENÇÃO, EXPORTAÇÃO E EXCLUSÃO DE DADOS

17.1. Durante a vigência da assinatura, os Dados da Contratante permanecerão disponíveis conforme plano contratado, limites técnicos, funcionalidades, rotinas de backup e regras da Plataforma.

17.2. Após cancelamento, encerramento ou suspensão prolongada, a Lumix poderá manter os Dados da Contratante por período razoável para permitir exportação, regularização, cumprimento de obrigações legais, segurança, auditoria, prevenção a fraudes, cobrança e exercício regular de direitos.

17.3. Salvo obrigação legal, ordem de autoridade, disputa, pendência financeira, necessidade de segurança ou condição contratual específica, a Lumix poderá excluir, anonimizar ou tornar indisponíveis os Dados da Contratante após o prazo de retenção operacional informado na Política de Privacidade ou em comunicação específica.

17.4. Registros de acesso, logs técnicos, trilhas de auditoria, comprovantes de contratação, pagamentos, notas, eventos de segurança e evidências de uso poderão ser mantidos por prazos superiores quando necessários ao cumprimento de obrigação legal, regulatória, fiscal, defesa em processos, prevenção a fraudes ou segurança da Plataforma.

17.5. A Contratante é responsável por solicitar exportação de dados antes do encerramento definitivo da conta.

18. FUNCIONALIDADES FISCAIS, NFC-e, NFe E INTEGRAÇÕES

18.1. Funcionalidades fiscais eventualmente oferecidas pela Plataforma possuem finalidade operacional e tecnológica, não substituindo contador, consultor tributário, advogado, sistema oficial governamental ou obrigação de conferência pela Contratante.

18.2. A Contratante é responsável por:
a) fornecer dados fiscais corretos;
b) manter certificado digital válido;
c) manter credenciais e tokens fiscais válidos;
d) configurar ambiente de homologação ou produção corretamente;
e) conferir produtos, CFOP, NCM, CST/CSOSN, impostos, valores, cliente, emitente e demais dados fiscais;
f) cumprir obrigações perante SEFAZ, Receita Federal, prefeitura, contador e demais autoridades.

18.3. A Lumix não responde por autuações, multas, rejeições, contingências, indisponibilidades de SEFAZ, erro de credencial, certificado vencido, dados fiscais incorretos, parametrização equivocada ou interpretação tributária adotada pela Contratante.

18.4. APIs fiscais de terceiros podem sofrer instabilidade, alteração, indisponibilidade, limitação, rejeição ou mudança de regras. A Lumix não garante aprovação de notas fiscais ou disponibilidade contínua de órgãos públicos e provedores externos.

19. DISPONIBILIDADE, MANUTENÇÃO E SUPORTE

19.1. A Lumix envidará esforços comercialmente razoáveis para manter a Plataforma disponível, segura e funcional, observadas manutenções, atualizações, limitações técnicas, incidentes, força maior, falhas de terceiros, indisponibilidades de internet e necessidades operacionais.

19.2. A Plataforma poderá ficar temporariamente indisponível por:
a) manutenção programada;
b) atualização de segurança;
c) correção emergencial;
d) falha de hospedagem, banco de dados, rede, DNS, energia, gateway ou serviço de terceiro;
e) ataque cibernético;
f) mau uso da Contratante;
g) eventos de força maior.

19.3. A Lumix não garante disponibilidade ininterrupta, ausência absoluta de erros, compatibilidade com todos os dispositivos, navegadores, extensões, redes, impressoras, APIs, bibliotecas ou configurações locais.

19.4. O suporte será prestado pelos canais oficiais, em horário, prioridade e formato definidos pela Lumix, podendo variar conforme plano contratado.

19.5. A Lumix poderá recusar suporte para problemas causados por:
a) alteração não autorizada no sistema;
b) ambiente local da Contratante;
c) internet, equipamento, impressora, navegador, antivírus ou bloqueio de rede;
d) uso fora das instruções;
e) integrações externas não homologadas;
f) credenciais inválidas ou vencidas;
g) manipulação indevida de banco de dados, código, API ou infraestrutura.

20. PROPRIEDADE INTELECTUAL

20.1. A Plataforma, marca, layout, fluxos, códigos, telas, componentes, documentação, identidade visual, banco de dados estrutural, regras de negócio, automações, textos, relatórios, modelos, design, integrações, melhorias e demais elementos pertencem à Lumix ou a seus licenciantes.

20.2. A Contratante não poderá copiar, reproduzir, vender, licenciar, alugar, distribuir, disponibilizar, modificar, desmontar, realizar engenharia reversa, criar produto concorrente baseado na Plataforma ou explorar comercialmente qualquer elemento da Lumix sem autorização expressa.

20.3. Sugestões, feedbacks, ideias, melhorias, solicitações de recursos e comentários fornecidos pela Contratante poderão ser utilizados pela Lumix para aprimorar a Plataforma, sem obrigação de remuneração, exclusividade ou reconhecimento individual, respeitados os dados pessoais e informações confidenciais.

21. CONFIDENCIALIDADE

21.1. As partes comprometem-se a manter sigilo sobre informações confidenciais recebidas em razão da contratação, incluindo dados técnicos, comerciais, financeiros, estratégicos, credenciais, documentos, métricas internas, informações de clientes, código, arquitetura, integrações e segredos de negócio.

21.2. A obrigação de confidencialidade não se aplica a informações:
a) públicas sem violação contratual;
b) já conhecidas legitimamente pela parte receptora;
c) recebidas de terceiro autorizado;
d) exigidas por lei, ordem judicial, autoridade competente ou obrigação regulatória.

22. SERVIÇOS DE TERCEIROS

22.1. A Plataforma pode depender de Serviços de Terceiros para hospedagem, armazenamento, banco de dados, pagamentos, e-mails, WhatsApp, emissão fiscal, APIs, autenticação, mapas, analytics, suporte e outras funcionalidades.

22.2. A Lumix não controla integralmente Serviços de Terceiros e não responde por falhas, alterações, bloqueios, indisponibilidades, preços, políticas, termos de uso, decisões, rejeições, limitações ou encerramentos desses serviços, salvo quando houver culpa comprovada da Lumix nos limites legais.

22.3. A Contratante deverá cumprir os termos, políticas e regras dos terceiros utilizados, inclusive gateways de pagamento, provedores de mensageria, Meta/WhatsApp, provedores fiscais e autoridades públicas.

23. LIMITAÇÃO DE RESPONSABILIDADE

23.1. Na máxima extensão permitida por lei, a Lumix não será responsável por danos indiretos, lucros cessantes, perda de faturamento, perda de oportunidade, perda de clientela, dano reputacional, paralisação de negócio, falha de terceiros, perda causada por erro de Usuário, campanha indevida, cadastro incorreto, uso abusivo, decisão comercial da Contratante ou descumprimento legal pela Contratante.

23.2. A Plataforma é ferramenta de apoio. A Lumix não garante aumento de vendas, conversão de campanhas, recuperação de clientes, aprovação fiscal, ausência de inadimplência, desempenho financeiro, resultado comercial ou sucesso empresarial.

23.3. A responsabilidade total da Lumix, quando legalmente reconhecida e não decorrente de dolo, culpa grave, violação intencional ou obrigação legal não limitável, ficará limitada aos valores efetivamente pagos pela Contratante à Lumix nos 3 (três) meses anteriores ao evento que deu origem à reclamação.

23.4. A limitação acima não se aplica quando a legislação aplicável vedar a limitação de responsabilidade.

24. INDENIZAÇÃO

24.1. A Contratante deverá indenizar e manter a Lumix livre de perdas, reclamações, multas, condenações, custos, despesas e honorários decorrentes de:
a) uso ilícito da Plataforma;
b) dados inseridos sem base legal;
c) mensagens enviadas sem autorização;
d) violação de direitos de Clientes Finais;
e) conteúdo, imagens, anexos ou documentos enviados pela Contratante;
f) uso indevido de WhatsApp, e-mail, campanhas ou automações;
g) descumprimento fiscal, tributário, contábil, consumidor ou regulatório pela Contratante;
h) violação destes Termos por Usuários da Contratante;
i) acesso indevido causado por falha de gestão de credenciais pela Contratante;
j) informações falsas, incompletas ou desatualizadas fornecidas pela Contratante.

25. RESCISÃO

25.1. A Lumix poderá rescindir, suspender ou limitar o acesso imediatamente, com ou sem aviso prévio, quando houver:
a) fraude;
b) inadimplência;
c) violação grave destes Termos;
d) risco à segurança;
e) ordem judicial ou administrativa;
f) uso ilícito;
g) tentativa de invasão;
h) abuso de mensagens;
i) ameaça à integridade da Plataforma;
j) fornecimento de dados falsos;
k) violação de direitos de terceiros;
l) utilização que possa gerar risco jurídico, técnico ou reputacional relevante.

25.2. A rescisão não prejudica cobrança de valores devidos, apuração de responsabilidades, preservação de provas, retenção de logs, obrigações de confidencialidade, propriedade intelectual, proteção de dados e demais cláusulas que por sua natureza devam sobreviver ao término.

26. ALTERAÇÕES DOS TERMOS

26.1. A Lumix poderá atualizar estes Termos para refletir alterações legais, técnicas, comerciais, operacionais, de segurança, de funcionalidades ou de modelo de negócio.

26.2. Alterações relevantes serão comunicadas por meio razoável. O uso continuado da Plataforma após a comunicação ou publicação da nova versão representará aceite da versão atualizada.

26.3. Caso a Contratante não concorde com a alteração, poderá cancelar o serviço, observadas obrigações pendentes e condições comerciais aplicáveis.

27. COMUNICAÇÕES OFICIAIS

27.1. Comunicações oficiais poderão ser realizadas por e-mail cadastrado, aviso no painel, WhatsApp oficial, telefone, notificação dentro da Plataforma ou outro meio informado pela Contratante.

27.2. A Contratante é responsável por manter canais de contato atualizados e por acompanhar notificações, cobranças, avisos de segurança, mudanças contratuais e solicitações de suporte.

28. DISPOSIÇÕES GERAIS

28.1. A tolerância de uma parte quanto ao descumprimento de qualquer obrigação não constituirá renúncia, novação ou alteração contratual.

28.2. Se qualquer cláusula for considerada inválida, ilegal ou inexequível, as demais permanecerão em pleno vigor, devendo a cláusula afetada ser interpretada ou substituída por disposição válida que mais se aproxime da intenção econômica e jurídica original.

28.3. A Contratante não poderá ceder, transferir ou sublicenciar seus direitos e obrigações sem autorização prévia da Lumix.

28.4. A Lumix poderá ceder ou transferir estes Termos em caso de reorganização societária, venda de ativos, fusão, aquisição, sucessão, parceria estratégica ou alteração operacional, desde que preservados os direitos essenciais da Contratante.

29. LEI APLICÁVEL E FORO

29.1. Estes Termos serão regidos pelas leis da República Federativa do Brasil.

29.2. Fica eleito o foro da Comarca de [INSERIR CIDADE/UF DA SEDE DA LUMIX], salvo quando norma legal obrigatória determinar foro diverso.

30. CONTATO

30.1. Para suporte, solicitações, dúvidas contratuais, privacidade, segurança ou cancelamento, a Contratante poderá entrar em contato pelos canais oficiais:
E-mail: [INSERIR E-MAIL OFICIAL]
WhatsApp/Suporte: [INSERIR WHATSAPP OFICIAL]
Endereço: [INSERIR ENDEREÇO]
Encarregado/DPO ou canal de privacidade: [INSERIR E-MAIL DE PRIVACIDADE, SE HOUVER]

31. BASES NORMATIVAS CONSIDERADAS

31.1. Este documento foi estruturado considerando, entre outras normas aplicáveis:
a) Lei nº 13.709/2018 - Lei Geral de Proteção de Dados Pessoais (LGPD);
b) Lei nº 12.965/2014 - Marco Civil da Internet;
c) Lei nº 8.078/1990 - Código de Defesa do Consumidor, quando aplicável;
d) Código Civil Brasileiro;
e) regulamentações e orientações da Autoridade Nacional de Proteção de Dados (ANPD), quando aplicáveis;
f) normas fiscais, tributárias e de emissão de documentos fiscais, quando aplicáveis à atividade da Contratante.

ANEXO I - ADITIVO DE TRATAMENTO DE DADOS PESSOAIS

A. OBJETO DO TRATAMENTO

A.1. O tratamento de dados pessoais realizado pela Lumix em nome da Contratante tem por finalidade viabilizar o funcionamento da Plataforma, incluindo cadastro de clientes, ordens de serviço, anexos, comunicação, automações, relatórios, suporte, segurança, armazenamento, backup, integrações e demais funcionalidades contratadas.

B. CATEGORIAS DE DADOS

B.1. Poderão ser tratados, conforme uso da Contratante:
a) nome;
b) telefone;
c) WhatsApp;
d) e-mail;
e) endereço;
f) data de nascimento;
g) histórico de atendimento;
h) dados de compra;
i) dados de ordem de serviço;
j) fotos e anexos;
k) receitas oftalmológicas;
l) dados financeiros e fiscais;
m) preferências de atendimento;
n) logs de acesso;
o) dados de usuários internos;
p) outros dados inseridos pela Contratante.

C. CATEGORIAS DE TITULARES

C.1. Clientes Finais da Contratante, leads, contatos comerciais, pacientes/clientes de óticas, colaboradores da Contratante, administradores, usuários internos, representantes e responsáveis financeiros.

D. INSTRUÇÕES DA CONTROLADORA

D.1. A Lumix tratará os dados conforme instruções documentadas da Contratante, estes Termos, a Política de Privacidade, a legislação aplicável e necessidades técnicas de prestação do serviço.

D.2. A Lumix poderá recusar instrução que considere ilegal, insegura, abusiva, incompatível com a Plataforma ou capaz de violar direitos de terceiros.

E. SUBOPERADORES

E.1. A Contratante autoriza o uso de suboperadores necessários à prestação do serviço, desde que a Lumix adote medidas razoáveis para selecionar fornecedores com padrões compatíveis de segurança, confidencialidade e proteção de dados.

F. SEGURANÇA

F.1. A Lumix adotará medidas técnicas e administrativas proporcionais ao risco, sem garantia de segurança absoluta, incluindo controles de acesso, segregação lógica, proteção de infraestrutura, registro de eventos e outras práticas compatíveis com a operação SaaS.

G. INCIDENTES

G.1. A Lumix notificará a Contratante sobre incidente relevante envolvendo dados pessoais sob seu tratamento, quando aplicável, fornecendo informações razoavelmente disponíveis para permitir avaliação, mitigação e cumprimento de obrigações legais pela Contratante.

H. TÉRMINO DO TRATAMENTO

H.1. Encerrada a contratação, os dados serão mantidos, excluídos, anonimizados ou devolvidos conforme estes Termos, a Política de Privacidade, obrigações legais, prazos técnicos, retenção de logs, segurança e exercício regular de direitos.

I. RESPONSABILIDADE DA CONTROLADORA

I.1. A Contratante, como Controladora dos dados dos Clientes Finais, permanece responsável por definir bases legais, finalidades, prazos de retenção, avisos de privacidade, atendimento a titulares, conteúdo das mensagens, campanhas, importações e legitimidade dos dados inseridos na Plataforma.

FIM DO DOCUMENTO.`;

function makeId(value) {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/^anexo\s+([ivxlcdm]+)\s+-\s+/, 'anexo-$1-')
    .replace(/^\d+\.\s*/, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function cleanSummaryLabel(value) {
  return String(value)
    .replace(/^\d+\.\s*/, '')
    .replace(/^ANEXO\s+([IVXLCDM]+)\s+-\s+/i, 'Anexo $1 - ')
    .toLowerCase()
    .replace(/^./, (letter) => letter.toUpperCase());
}

const summaryHeadings = TERMS_TEXT
  .split('\n')
  .map((line) => line.trim())
  .filter((line) => /^(\d+)\.\s+/.test(line) || /^ANEXO\s+[IVXLCDM]+\s+-\s+/i.test(line));

const summaryLinks = summaryHeadings.map((title) => ({
  href: `#${makeId(title)}`,
  label: cleanSummaryLabel(title),
}));

const embeddedLegalStyles = `
  .legal-document--terms {
    max-width: 900px;
    margin: 0 auto;
    color: #334155;
  }

  .legal-document--terms section {
    scroll-margin-top: 96px;
  }

  .legal-document--terms h2 {
    position: relative;
    margin: 42px 0 16px;
    padding: 0 0 13px;
    border-bottom: 1px solid #e6ebf1;
    color: #171a21;
    font-family: 'Nunito', 'Inter', system-ui, sans-serif;
    font-size: 1.26rem;
    line-height: 1.3;
    font-weight: 900;
    letter-spacing: -0.025em;
  }

  .legal-document--terms h2::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 42px;
    height: 2px;
    border-radius: 999px;
    background: #1a73e8;
  }

  .legal-document--terms h3 {
    margin: 30px 0 12px;
    color: #20242c;
    font-family: 'Nunito', 'Inter', system-ui, sans-serif;
    font-size: 1rem;
    line-height: 1.4;
    font-weight: 850;
    letter-spacing: -0.015em;
  }

  .legal-document--terms p,
  .legal-document--terms li {
    color: #46505f;
    font-family: 'Inter', system-ui, sans-serif;
    font-size: 0.92rem;
    line-height: 1.82;
    font-weight: 450;
  }

  .legal-document--terms p {
    margin: 0 0 15px;
  }

  .legal-document--terms p > strong:first-child {
    color: #20242c;
    font-weight: 800;
  }

  .legal-document--terms ul {
    margin: 6px 0 22px;
    padding-left: 1.3rem;
  }

  .legal-document--terms li {
    padding-left: 4px;
  }

  .legal-document--terms li + li {
    margin-top: 7px;
  }

  .legal-document--terms li::marker {
    color: #1a73e8;
  }

  .legal-document--terms li strong {
    color: #20242c;
    font-weight: 800;
  }

  .legal-document--terms a {
    color: #1a73e8;
    font-weight: 650;
    text-decoration: none;
  }

  .legal-document--terms a:hover {
    text-decoration: underline;
  }

  .legal-end {
    margin: 46px 0 4px !important;
    padding-top: 20px;
    border-top: 1px solid #e6ebf1;
    color: #8b93a1 !important;
    text-align: center;
    font-size: 0.72rem !important;
    font-weight: 750 !important;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  @media (max-width: 720px) {
    .legal-document--terms h2 {
      margin-top: 34px;
      font-size: 1.08rem;
      line-height: 1.35;
    }

    .legal-document--terms h3 {
      margin-top: 25px;
      font-size: 0.95rem;
    }

    .legal-document--terms p,
    .legal-document--terms li {
      font-size: 0.86rem;
      line-height: 1.75;
    }

    .legal-document--terms ul {
      padding-left: 1.15rem;
    }
  }
`;

function renderLegalContent() {
  const lines = TERMS_TEXT.split('\n').map((line) => line.trim()).filter(Boolean);
  const nodes = [];
  let pendingList = [];

  const flushList = () => {
    if (!pendingList.length) return;
    nodes.push(
      <ul key={`list-${nodes.length}`}>
        {pendingList.map((item) => (
          <li key={item.key}>
            <strong>{item.marker})</strong> {item.text}
          </li>
        ))}
      </ul>
    );
    pendingList = [];
  };

  lines.forEach((line, index) => {
    if (line === 'TERMOS DE USO E CONTRATO DE PRESTAÇÃO DE SERVIÇOS SaaS' || line === 'PLATAFORMA LUMIX ÓTICAS') {
      return;
    }

    const listMatch = line.match(/^([a-z])\)\s+(.+)$/);
    if (listMatch) {
      pendingList.push({ key: `${index}-${listMatch[1]}`, marker: listMatch[1], text: listMatch[2] });
      return;
    }

    flushList();

    if (/^(\d+)\.\s+/.test(line) || /^ANEXO\s+[IVXLCDM]+\s+-\s+/i.test(line)) {
      nodes.push(
        <section id={makeId(line)} key={`section-${index}`}>
          <h2>{line}</h2>
        </section>
      );
      return;
    }

    if (/^[A-Z]\.\s+/.test(line)) {
      nodes.push(<h3 key={`h3-${index}`}>{line}</h3>);
      return;
    }

    if (line.startsWith('ATENÇÃO:')) {
      nodes.push(
        <div className="legal-alert" key={`alert-${index}`}>
          <strong>ATENÇÃO:</strong> {line.replace('ATENÇÃO:', '').trim()}
        </div>
      );
      return;
    }

    if (line === 'FIM DO DOCUMENTO.') {
      nodes.push(<p className="legal-end" key={`end-${index}`}>FIM DO DOCUMENTO.</p>);
      return;
    }

    const clauseMatch = line.match(/^(\d+\.\d+\.?|[A-Z]\.\d+\.)\s+(.+)$/);
    if (clauseMatch) {
      nodes.push(
        <p key={`p-${index}`}>
          <strong>{clauseMatch[1]}</strong> {clauseMatch[2]}
        </p>
      );
      return;
    }

    nodes.push(<p key={`p-${index}`}>{line}</p>);
  });

  flushList();
  return nodes;
}

export default function TermosUso() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const legalContent = useMemo(() => renderLegalContent(), []);

  return (
    <LegalLayout
      eyebrow="Contrato de Serviço SaaS"
      title="Termos de Uso"
      description="Estes termos regulam o acesso e a utilização da plataforma Lumix Óticas por empresas, administradores e usuários autorizados."
      summaryLinks={summaryLinks}
    >
      <style>{embeddedLegalStyles}</style>
      <div className="legal-document legal-document--terms">
        {legalContent}
      </div>
    </LegalLayout>
  );
}
